export var ID = '@organizationManagement';
export default {
    ID: ID,
    POST_ORGANIZATION_LIST: ID + "/POST_ORGANIZATION_LIST",
    POST_CREAT_ORGANIZATION: ID + "/POST_CREAT_ORGANIZATION",
    PUT_UPDATE_ORGANIZATION: ID + "/PUT_UPDATE_ORGANIZATION",
    DELETE_ORGANIZATION: ID + "/DELETE_ORGANIZATION"
};
